module.exports = __webpack_public_path__ + "static/icon-256x256-c07e7774beb2054cf76418f0d327334e.png";